/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface TypeEvaluationSearch
 */
export interface TypeEvaluationSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof TypeEvaluationSearch
     */
    libelle?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof TypeEvaluationSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof TypeEvaluationSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof TypeEvaluationSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypeEvaluationSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TypeEvaluationSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TypeEvaluationSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the TypeEvaluationSearch interface.
 */
export function instanceOfTypeEvaluationSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TypeEvaluationSearchFromJSON(json: any): TypeEvaluationSearch {
    return TypeEvaluationSearchFromJSONTyped(json, false);
}

export function TypeEvaluationSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeEvaluationSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'libelle': !exists(json, 'libelle') ? undefined : TextSearchFromJSON(json['libelle']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function TypeEvaluationSearchToJSON(value?: TypeEvaluationSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'libelle': TextSearchToJSON(value.libelle),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

